import { request } from "@/util/request";
//登录
export function wxLoginApi(data){
	return request('/user/wxLogin',data,'POST')
}
//获取设备列表
export function searchFacilityApi(data){
	return request('/waterFacility/search',data,'POST')
}
// 根据openId获取设备列表
export function getDevicesByiOpenId(openId){
	return request(`/userFacility/getListByOpenId?openId=${openId}`,{},'GET');
}
// 根据设备Id获取设备信息
export function getDeviceInfoByDeviceId(deviceId){
	return request(`/userFacility/getDataByCode?facilityCode=${deviceId}`,{},"GET")
}
// 根据设备二维码绑定设备
export function bindDevice(data){
	return request('/userFacility/create',data,'POST')
}
// 移除用户绑定的设备
export function deleteDevice(data){
	return request('/userFacility/modify',data,'POST')
}
// 传递设备实时控制参数
export function deviceControlInfo(data){
	return request('/waterFacility/openAndClose',data,'POST')
}
// 获取操作记录
export function getOpeInfo(data){
	return request(`/facilityOperatingRecord/getListByFacilityCode?facilityCode=${data}`,{},'GET')
}
// 获取上一次的实时控制数据
export function getControlInfo(data){
	return request(`/dataUploadRecord/getDataUploadByCode?facilityCode=${data}`,{},'GET')
}




